import React, { Component } from 'react';
import CameraIcon from '../../assets/images/camera-icon.svg';

import './ImageUploader.scss';

class ImageUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      imagePreviewUrl: '',
      showCropper: false,
    };
  }

  handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    if (file) {
      reader.onloadend = () => {
        this.setState({
          file: file,
          imagePreviewUrl: reader.result,
        });
      };

      this.props.handlePickPhoto(file, this.props.type);
        
    }
    e.target.value = null;
  }

  handleOnChange(e) {
    e.preventDefault();
  }

  render() {
    let { file, cropFile, height, width, defaultImage, top, left, bottom, right, borderRadius, imageTop } = this.props;

    height = height ? height : null;
    width = width ? width : null;
    top = top ? top : null;
    left = left ? left : null;
    bottom = bottom ? bottom : null;
    right = right ? right : null;
    borderRadius = borderRadius ? borderRadius : null;
    imageTop = imageTop ? imageTop : null;

    let style = {
      height: height,
      width: width,
      top: top,
      left: left,
      bottom: bottom,
      right: right,
      borderRadius: borderRadius,
    };
    
    let image = file;
    if(cropFile) {
      image = cropFile;
    }
    let imagePreview = null;
    let imageOverlay = (
        <div className="edit-image" style={style} onChange={(e)=>this.handleImageChange(e)}>
          <img className="camera-icon" src={CameraIcon} alt="camera icon" style={{ marginTop: imageTop }}/>
          <input className="file-input" type="file" accept="image/*" title=" "/>
        </div>
    );

    if (file || cropFile) {
      imagePreview = <img className="image" src={image} alt="profile"/>;
    }
    else {
      imagePreview = <img className="image" src={defaultImage} alt="profile" />;
    }

    return (
      <div className="image-wrapper" style={style}>
        {imagePreview}
        {imageOverlay}
      </div>
    );
  }
}
  
export default (ImageUploader);



// WEBPACK FOOTER //
// ./src/components/ImageUploader/index.js